import paymentReportReducer from './PaymentReportReducer';
import otherPaymentReportReducer from './OtherPaymentReportReducer';

const paymentReportReducers ={
  paymentReport: paymentReportReducer,
  otherPaymentReport: otherPaymentReportReducer
};

export default paymentReportReducers;